var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"text-center py-0"},[_c('div',[_c('h3',{staticClass:"choose",staticStyle:{"text-transform":"uppercase"}},[_vm._v("Choose App And Action")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }